import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"

import Select from "../../../../../../../core/gd-form/form-element/select-new/select-new"
import CustomView_rowComponent from "./row-component"

type Props = {
    label                       : string

    form                        : FormManager
    formFieldName               : string

    options                 : {
        value   : any
        label   : string
        icon?   : string
    }[]

    disabled?                   : boolean
}

export default function SelectOption(props: Props) {

    return (
        <CustomView_rowComponent label={props.label}>
            <Select form={props.form}
                    name={props.formFieldName}
                    options={props.options}/>
            <FormError form={props.form}
                       name={props.formFieldName}/>
        </CustomView_rowComponent>
    )
}